import { JobApplicationStatusLabel } from '@/components/JobApplicationStatusLabel';
import { JobButton } from '@/modules/JobButton';
import JobCard from '@/modules/JobCard';
import JobFavouriteButton from '@/modules/JobFavouriteButton';
import { IJobDetail } from '@/types/jobs';
import { generateJobDetailsURL } from '@/utils/jobListingHelper';
import { useAnalytics } from '@/utils/useAnalytics';
import React from 'react';

export type JobListingJobCardProps = {
  job: IJobDetail;
  isHighlighted?: boolean;
};

const JobListingJobCard = ({ job, isHighlighted = false }: JobListingJobCardProps) => {
  const track = useAnalytics();
  const subspcialityOrSpeciality = job.subspeciality ? job.subspeciality : job.speciality;

  return (
    <JobCard
      topButtonElement={
        <>
          {!job.appliedStatus && (
            <JobFavouriteButton
              id={job.id}
              jobNumber={job.jobNumber}
              favourited={job.isSaved}
              style={null}
            />
          )}
        </>
      }
      bottomButtonElement={
        <>
          {job.appliedStatus ? (
            <JobApplicationStatusLabel status={job.appliedStatus} />
          ) : (
            <JobButton
              buttonSize="medium"
              id={job.id}
              jobNumber={job.jobNumber}
              url={generateJobDetailsURL(job.jobNumber, job.grade, subspcialityOrSpeciality)}
              text="See Details"
              trackingCallback={() => {
                track('Job Details', {
                  'Details Origin': 'Job Card',
                  'Details Action': 'Button',
                  jobNumber: job.jobNumber,
                });
              }}
            />
          )}
        </>
      }
      data={job}
      isJobSummary={true}
      isHighlighted={isHighlighted}
    />
  );
};

export default JobListingJobCard;
